import { Component, OnInit, Input } from '@angular/core';

import { InvestSic } from '@classes/invest/invest-sic/invest-sic';

@Component({
    selector: 'app-sic-eval',
    templateUrl: './sic-eval.component.html',
    styleUrls: ['./sic-eval.component.scss']
})
export class SicEvalComponent implements OnInit {
    @Input() invest: InvestSic;

    constructor() { }

    ngOnInit() {
    }

}
